import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PAGE_PATHS } from '../../../../../../../types';

const defaultFilter = {};

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/targets/activityLog/$id/')({
  validateSearch: zodValidator(withDefaults(schema.TARGETS, defaultFilter)),
  search: {
    middlewares: [stripSearchParams(defaultFilter)],
  },
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.TARGETS });
    context.validatePermissions({ isAllowed, preload });
  },
});
